import React from "react";
import tw from "twin.macro";
import styled from "styled-components";

import Hero from "./hero";
import Partners from "./partners";
import Testimonials from "./testimonials";
import MailingListCta from "components/composites/MailingListCta";
import Footer from "screens/footer";

import headerImgWebp from "./header_web.webp";
import headerImgJpg from "./header_web.jpg";

import { LeftContent, Column } from "./containers";
import { P, H } from "components/typography";

const HeroBg = styled.section`
  ${tw`w-full lg:w-3/4 my-8 bg-cover bg-center`}
  @media (min-width: 1024px) {
    background-image: url(${headerImgJpg});
    background-image: -webkit-image-set(
      url(${headerImgWebp}) type("image/webp"),
      url(${headerImgJpg}) type("image/jpeg")
    );
    background-image: image-set(
      url(${headerImgWebp}) type("image/webp"),
      url(${headerImgJpg}) type("image/jpeg")
    );
  }
`;

const Home: React.FC = () => (
  <article>
    <Hero />
    <Partners />

    <section tw="block lg:flex flex-row py-2.5">
      <Column tw="flex justify-end h-inherit">
        <LeftContent tw="text-center lg:text-left">
          <div>
            <i className="fas fa-heart" tw="text-3xl pb-3"></i>
            <H.Two tw="pb-4">Browse + Order</H.Two>
            <P.Medium tw="lg:pb-5">
              We work with the best restaurants in the city to bring you the
              best food--without the traffic or parking. Meal planning,
              birthdays, anniversaries, BBQs, and your Thursday night dinner
              have never been easier at home!
            </P.Medium>
          </div>
          <div tw="mt-6 lg:mt-0">
            <i className="fas fa-laugh-beam" tw="text-3xl pb-3"></i>
            <H.Two tw="pb-4">Pick up + Enjoy!</H.Two>
            <P.Medium>
              We bring the food to your area--meet us for pickup and take it
              home to your family. Prep and heat your dinner, and enjoy a
              stress-free dinner from an old--or new--favorite!
            </P.Medium>
          </div>
        </LeftContent>
      </Column>
      <Column tw="hidden lg:flex h-inherit">
        <HeroBg />
      </Column>
    </section>

    <section tw="block lg:flex flex-row mb-20">
      <Column tw="flex justify-end h-inherit">
        <Testimonials />
      </Column>
      <Column tw="flex mt-6 lg:mt-0 h-inherit">
        <div tw="w-full lg:w-3/4 flex h-inherit">
          <MailingListCta />
        </div>
      </Column>
    </section>
    <Footer />
  </article>
);

export default Home;
